var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook3Line = function SvgBook3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 4.8H8a1.8 1.8 0 1 0 0 3.6h12.6v11.7a.9.9 0 0 1-.9.9H8a3.6 3.6 0 0 1-3.6-3.6V6.6A3.6 3.6 0 0 1 8 3h11.7a.9.9 0 0 1 .9.9zM6.2 17.4A1.8 1.8 0 0 0 8 19.2h10.8v-9H8a3.6 3.6 0 0 1-1.8-.481zm13.5-9.9H8a.9.9 0 0 1 0-1.8h11.7z"
  })));
};
export default SvgBook3Line;